module.exports = __webpack_public_path__ + "static/media/logo-mobile-white.74d73c0c.svg";